import { createFileRoute } from '@tanstack/react-router'

import { OperationalWorkspace } from '#components/features/operations/operational-workspace'
import { TablesView } from '#components/features/tables/tables-view'
import { useOperationalWorkspaceMode } from '#hooks/use-operational-workspace-mode'
import { requireOperationalWorkspace } from '#utils/operational-route'

export const Route = createFileRoute('/mesas')({
  beforeLoad: ({ context }) => requireOperationalWorkspace(context.queryClient),
  head: () => ({
    meta: [{ title: 'Mesas | UseComanda' }],
  }),
  component: TablesPage,
})

function TablesPage() {
  const mode = useOperationalWorkspaceMode()

  return (
    <OperationalWorkspace>
      <div
        className={
          mode === 'waiter'
            ? 'bg-muted/20 min-h-svh px-4 pb-24 sm:px-6'
            : 'bg-muted/20 min-h-full p-6 sm:p-8'
        }
      >
        <div
          className={
            mode === 'waiter' ? 'mx-auto max-w-2xl' : 'mx-auto max-w-6xl'
          }
        >
          <TablesView variant={mode} />
        </div>
      </div>
    </OperationalWorkspace>
  )
}
